import { render, staticRenderFns } from "./ModalEventDetails.vue?vue&type=template&id=9d7849e4&scoped=true&"
import script from "./ModalEventDetails.vue?vue&type=script&lang=ts&"
export * from "./ModalEventDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7849e4",
  null
  
)

export default component.exports